import {
  CREATE_SPECIALDAY_REQUEST,
  CREATE_SPECIALDAY_ERROR,
  CREATE_SPECIALDAY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITY_REQUEST = CREATE_SPECIALDAY_REQUEST;
  context.CREATE_ENTITY_ERROR = CREATE_SPECIALDAY_ERROR;
  context.CREATE_ENTITY_SUCCESS = CREATE_SPECIALDAY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "specialday";
  context.entityLocation = RESOURCES.SpecialDays;
  context.hasOrganisation = true;

  return context.execute(context)(entity)(state, action);
};